// extracted by mini-css-extract-plugin
export var btn = "L_mB z_s8 z_sX d_bz d_bP d_bD d_dw";
export var full = "L_v3 d_w d_H";
export var hoverStyle = "L_mF";
export var zoom = "L_mG";